import ApiService from './api.service';
class DashboardError extends Error {
  constructor(errorCode, message) {
    super(message);
    this.name = this.constructor.name;
    this.message = message;
    this.errorCode = errorCode;
  }
}

const DashboardService = {
  fetchBalances: async function() {
    try {
      const response = await ApiService.get('/dashboard/account-balances');
      return response.data;
    } catch (error) {
      throw new DashboardError(
        error.response.status,
        error.response.data.detail
      );
    }
  },

  fetchCharts: async function() {
    try {
      const response = await ApiService.get('/dashboard/charts');
      return response.data;
    } catch (error) {
      throw new DashboardError(
        error.response.status,
        error.response.data.detail
      );
    }
  },

  fetchStats: async function() {
    try {
      const response = await ApiService.get('/dashboard/stats');
      return response.data;
    } catch (error) {
      throw new DashboardError(
        error.response.status,
        error.response.data.detail
      );
    }
  },
};

export { DashboardService, DashboardError };
